import React from "react";
import { Skeleton, Space } from "antd";

export const DHSApprovalDetailLoading: React.FC = () => {
  return (
    <div>
      <Skeleton.Button active style={{ width: 100, marginBottom: 16 }} />

      <div className="mainTitle">
        <Skeleton.Input active style={{ width: 220, height: 32 }} />
        <Space>
          <Skeleton.Button active style={{ width: 90 }} />
        </Space>
      </div>

      <Skeleton active paragraph={{ rows: 8 }} style={{ marginBottom: 24 }} />

      <Skeleton active paragraph={{ rows: 8 }} />
    </div>
  );
};
